@use '@design/design-tokens/typography/typography' as *;

.cards {
  gap: 20px;
}

.row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
}

.index {
  @include typography-v2-title-sm;
  color: var(--text-primary);
  width: 18px;
  flex-shrink: 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.textBlock {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.headline {
  @include typography-v2-title-sm;
}

.description {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.themes {
  @include typography-v2-body-xs;
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  align-items: center;
}



.themeSoft {
  color: var(--text-soft);
}

.themeLink {


  &:hover {
    text-decoration: underline;
    text-underline-offset: 2px;
  }
}